import { gql } from '@apollo/client';
import { ExternalIdFilter } from 'gql-types';

export namespace ExternalId {
    export type Filters = ExternalIdFilter;
}

export const ExternalIdFragment = gql`
    fragment ExternalIdFragment on ExternalId {
        system
        type
        value
    }
`;
export interface IExternalId {
    system: string;
    type: string | null;
    value: string;
}

// Convenience utility for mid-migration checks about whether there is an external ID between the old and new external ID types.
export const hasExternalId = (
    externalId: string | null,
    externalIds: IExternalId[] | null,
): boolean => {
    if (!externalId && externalIds?.length === 0) {
        return false;
    }
    return true;
};
